import React from 'react'
import Footer from '../../components/Footer/Footer'
import classes from './accountWrapper.module.css'
import gridClasses from '../../styles/grid.module.css'
import { NavLink, Redirect, Route, Switch } from 'react-router-dom'
import classNames from 'classnames'
import { Button, ButtonVariants } from '../../components/Button/Button'
import { AuthenticatedHeader } from '../../components/Header/AuthenticatedHeader'
import { ReactComponent as Profile } from '../../assets/icons/paid-profile-profile.svg'
import { ReactComponent as ProfileActive } from '../../assets/icons/paid-profile-profile-active.svg'
import { ReactComponent as Subscription } from '../../assets/icons/paid-profile-subscription.svg'
import { ReactComponent as SubscriptionActive } from '../../assets/icons/paid-profile-subscription-active.svg'
import { ReactComponent as Card } from '../../assets/icons/paid-profile-credit-card.svg'
import { ReactComponent as CardActive } from '../../assets/icons/paid-profile-credit-card-active.svg'
import { ReactComponent as Password } from '../../assets/icons/paid-profile-password.svg'
import { ReactComponent as PasswordActive } from '../../assets/icons/paid-profile-password-active.svg'
import { ReactComponent as RatingIcon } from '../../assets/icons/rating.svg'
import { ReactComponent as CoursebookIcon } from '../../assets/icons/coursebook.svg'
import { ReactComponent as PresentationIcon } from '../../assets/icons/presentation.svg'
import ProfilePage from './Profile/Profile'
import CardsPage from './Card/Cards'
import SubscriptionPage from './Subscription/Subscription'
import PasswordPage from './Password/Password'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import userAvatar from '../../assets/images/avatar-dark.svg'
import { IMG_URL } from '../../api/api'
import { startWizard } from '../Wizard/wizardLogic'

const pages = [
    {
        text: 'Profile',
        id: 'profile',
        icon: Profile,
        activeIcon: ProfileActive,
        component: ProfilePage,
    },
    {
        text: 'Subscription',
        id: 'subscription',
        icon: Subscription,
        activeIcon: SubscriptionActive,
        component: SubscriptionPage,
    },
    {
        text: 'Password',
        id: 'password',
        icon: Password,
        activeIcon: PasswordActive,
        component: PasswordPage,
    },
]

const AccountWrapper = ({ match }) => {
    const { path } = match

    const user = useSelector(userSelectors.userDetails)

    return (
        <>
            <AuthenticatedHeader />
            <main>
                <div className={classes.accountTop}>
                    <div
                        className={classNames(
                            gridClasses.container,
                            gridClasses.containerTransparent,
                            classes.accountTopContainer
                        )}
                    >
                        <h1 className={classes.accountTopHeader}>My Account</h1>
                    </div>
                </div>
                <div
                    className={classNames(
                        classes.accountBody,
                        gridClasses.container
                    )}
                >
                    <div className={classes.accountSettings}>
                        <div className={classes.accountSettingsTop}>
                            {pages.map(
                                ({
                                    id,
                                    text,
                                    icon: Icon,
                                    activeIcon: ActiveIcon,
                                }) => (
                                    <NavLink
                                        to={`${path}/${id}`}
                                        activeClassName={
                                            classes.accountBodyContentTopLinkActive
                                        }
                                        className={classNames(
                                            classes.accountBodyContentTopLink
                                        )}
                                        key={id}
                                    >
                                        <Icon
                                            className={
                                                classes.accountBodyContentTopLinkImage
                                            }
                                        />
                                        <ActiveIcon
                                            className={classNames(
                                                classes.accountBodyContentTopLinkImage,
                                                classes.accountBodyContentTopLinkActiveImage
                                            )}
                                        />
                                        {text}
                                    </NavLink>
                                )
                            )}
                        </div>
                        <div className={classes.accountSettingsBody}>
                            <Switch>
                                {pages.map(({ id, component }) => (
                                    <Route
                                        path={`${path}/${id}`}
                                        component={component}
                                    />
                                ))}
                                <Route
                                    component={() => (
                                        <Redirect to={'/app/account/profile'} />
                                    )}
                                />
                            </Switch>
                        </div>
                    </div>
                    <div className={classes.accountSidebar}>
                        <img
                            src={user.profilepicture || userAvatar}
                            alt="User"
                            className={classes.accountSidebarUserImage}
                        />
                        <h3 className={classes.accountSidebarUserName}>
                            {`${user.firstname} ${user.lastname}`}
                        </h3>
                        <h5 className={classes.accountSidebarUserMail}>
                            {user.email}
                        </h5>
                        <span className={classes.accountSidebarSplit} />
                        <span className={classes.accountSidebarUserInfo}>
                            {user.bio || 'No bio added'}
                        </span>
                        <span className={classes.accountSidebarSplit} />
                        <div className={classes.accountStats}>
                            <p className={classes.accountStat}>
                                <span
                                    className={classes.accountStatIcon}
                                    style={{ '--color': '#93f2ff' }}
                                >
                                    <RatingIcon />
                                </span>
                                <span className={classes.accountStatBold}>
                                    {user.loyalitypoint}{' '}
                                </span>{' '}
                                Loyalty Point
                            </p>
                            <p className={classes.accountStat}>
                                <span
                                    className={classes.accountStatIcon}
                                    style={{ '--color': '#b4a3ff' }}
                                >
                                    <CoursebookIcon />
                                </span>
                                <span className={classes.accountStatBold}>
                                    {user.freeCourses}{' '}
                                </span>
                                Free Course(s)
                            </p>
                            <p className={classes.accountStat}>
                                <span
                                    className={classes.accountStatIcon}
                                    style={{ '--color': '#ffa969' }}
                                >
                                    <PresentationIcon />
                                </span>
                                <span className={classes.accountStatBold}>
                                    {user.freeClasses}{' '}
                                </span>
                                Free Class Slots
                            </p>
                        </div>
                        <Button
                            variant={ButtonVariants.secondaryOutline}
                            className={classes.accountActionButton}
                            outline
                            to={startWizard({ isUpgrade: true })}
                        >
                            Upgrade Plan
                        </Button>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    )
}

export default AccountWrapper
